import {
  Dumbbell,
  Footprints,
  Zap,
  Bike,
  Home,
  PersonStanding,
  Activity,
} from "lucide-react";

export const GOALS = [
  "More energy",
  "Weight loss",
  "Gym",
  "Walking",
  "Running",
  "Back to shape",
  "Consistency",
  "Healthy lifestyle",
];

export const ACTIVITY_TYPES = [
  { id: "Gym", icon: Dumbbell },
  { id: "Walk", icon: Footprints },
  { id: "Run", icon: Zap },
  { id: "Bike", icon: Bike },
  { id: "Home workout", icon: Home },
  { id: "Stretching", icon: PersonStanding },
  { id: "Other", icon: Activity },
];

export const DURATION_PRESETS = [10, 20, 30, 45, 60];

export const INTENSITIES = ["Light", "Medium", "Strong"];

export const MOODS = ["Tired", "Low", "Okay", "Good", "Energized"];

export const LEVELS = ["Starting", "Coming back", "Active"];

export const kebab = (s) => String(s).toLowerCase().replace(/\s+/g, "-");

export const activityIcon = (type) => {
  const found = ACTIVITY_TYPES.find((t) => t.id === type);
  return found ? found.icon : Activity;
};
